import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import ChevronUpOutlined from "../chevron/ChevronUpOutlined";
import ChevronDownOutlined from "../chevron/ChevronDownOutlined";
import removeUsersFromSubTeam from "../apis/removeUsersFromSubTeam";
import addUsersToSubTeam from "../apis/addUsersToSubTeam";

function EditUserInTeamModal({
  currentUser,
  edit_user_modal,
  set_edit_user_modal,
}) {
  const [dropdown_toggle, set_dropdown_toggle] = useState(false);
  const [dropdown_toggle_value, set_dropdown_toggle_value] = useState(
    edit_user_modal?.sub_team || "Default (Unassigned)"
  );
  useEffect(() => {
    set_dropdown_toggle_value(
      edit_user_modal?.sub_team || "Default (Unassigned)"
    );
  }, [edit_user_modal?.sub_team]);
// handle challanges APi for sub team 
  const handle_chalenges_Api = async () => {
    if (dropdown_toggle_value == "Default (Unassigned)") {
      await removeUsersFromSubTeam({
        team_code: currentUser.team.id,
        sub_name: edit_user_modal.sub_team,
        user_ids: [edit_user_modal.Username],
      });
    } else {
      await addUsersToSubTeam({
        team_code: currentUser.team.id,
        sub_name: dropdown_toggle_value,
        user_ids: [edit_user_modal.Username],
      });
    }
    set_edit_user_modal(null);
  };

  const handle_save = async () => {
    if (dropdown_toggle_value == "Default (Unassigned)") {
      await removeUsersFromSubTeam({
        team_code: currentUser.team.id,
        sub_name: edit_user_modal.sub_team,
        user_ids: [edit_user_modal.Username],
      });
    } else {
      await addUsersToSubTeam({
        team_code: currentUser.team.id,
        sub_name: dropdown_toggle_value,
        user_ids: [edit_user_modal.Username],
      });
    }
    set_edit_user_modal(null);
  };

  const check_disabled = () => {
    let res;
    if (
      !edit_user_modal?.sub_team &&
      dropdown_toggle_value == "Default (Unassigned)"
    ) {
      res = true;
    } else if (edit_user_modal?.sub_team == dropdown_toggle_value) {
      res = true;
    } else {
      res = false;
    }
    return res;
  };
  
  return (
    <Modal
      className="invites-teammates-modal edit-teammates-modal"
      centered
      isOpen={!!edit_user_modal}
      toggle={() => {
        set_edit_user_modal(null);
      }}
    >
      <ModalHeader toggle={() => set_edit_user_modal(null)}></ModalHeader>
      <ModalBody>
        <h3>Edit Teammate</h3>
        <p className="my-3">Choose the sub-team for your teammate.</p>

        <Dropdown
          isOpen={dropdown_toggle}
          toggle={() => set_dropdown_toggle(!dropdown_toggle)}
          value={dropdown_toggle_value}
        >
          <DropdownToggle className="toggle-item2">
            {dropdown_toggle_value || "Default (Unassigned)"}
            {dropdown_toggle ? (
              <ChevronUpOutlined color="#606060" />
            ) : (
              <ChevronDownOutlined color="#606060" />
            )}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() => {
                set_dropdown_toggle_value("Default (Unassigned)");
                set_dropdown_toggle(false);
              }}
            >
              Default (Unassigned)
            </DropdownItem>
            {currentUser?.team?.sub_teams?.map((s_team) => (
              <DropdownItem
                onClick={() => {
                  set_dropdown_toggle_value(s_team.sub_name);
                  set_dropdown_toggle(false);
                }}
              >
                {s_team.sub_name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>

        <div className="d-flex justify-content-between">
          <button
            className="cancel-btn"
            onClick={() => set_edit_user_modal(null)}
          >
            Cancel
          </button>
          <button
            className={`share-btn ${check_disabled() ? "disabled" : ""}`}
            onClick={handle_save}
            disabled={check_disabled()}
          >
            Save
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default EditUserInTeamModal;
